import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Component({
    selector: 'app-delete-card',
    templateUrl: './delete-card.component.html',
    styleUrls: ['./delete-card.component.scss']
})
export class DeleteCardComponent implements OnInit, OnDestroy {
    @Output() closeBtnClicked: EventEmitter<boolean> = new EventEmitter();
    @Output() deleteBtnClicked: EventEmitter<boolean> = new EventEmitter();

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor() {}

    ngOnInit() {}

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    public close(): void {
        this.closeBtnClicked.emit(true);
    }

    public delete(): void {
        this.close();
        this.deleteBtnClicked.emit(true);
    }
}
